import { useRef, useState } from 'react';

import { Image as ImageDiv, Wrapper } from './ProfileImage.styles';

type Props = {
  imgSrc: string;
  onLoad?: () => void;
  size?: number;
  style?: React.CSSProperties;
};

export const ProfileImage = ({ imgSrc, onLoad, size, style, ...rest }: Props) => {
  const ref = useRef<HTMLImageElement>(null);
  const [height, setHeight] = useState('auto');

  const OnImageLoad = () => {
    if (ref.current && ref.current.width > ref.current.height) {
      setHeight('100%');
    } else if (ref.current && ref.current.width < ref.current.height) {
      setHeight('auto');
    }
    onLoad && onLoad();
  };

  return (
    <Wrapper size={size} data-testid="profile-img" style={style}>
      <ImageDiv
        src={imgSrc}
        ref={ref}
        height={height}
        width={height === 'auto' ? '100%' : 'auto'}
        onLoad={OnImageLoad}
        {...rest}
      />
    </Wrapper>
  );
};
